<template>
    <vx-card title="Редактирование домена" id="loader">
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input v-model="form.domain" :danger="!!errors.domain" :danger-text="errors.domain"
                        autocomplete="off" label="Домен (в формате test.com)" class="mt-1 w-full required" />
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <label class="vs-input--label required">
                    Тип
                </label>
                <v-select disabled :clearable="false" :options="dicts.domainTypes" label="name"
                    placeholder="Выберите тип" class="w-full" v-model="form.typeId" :reduce="a => a.id">
                </v-select>
            </div>
        </div>

        <vs-button class="mt-5 mr-2" color="success" @click="save()" type="filled">
            Сохранить
        </vs-button>

        <vs-button class="mt-5" color="primary" @click="cancelEdit()" type="filled">
            Отмена
        </vs-button>
    </vx-card>
</template>


<script>
import vSelect from 'vue-select';
import axios from 'axios';

export default {
    name: 'rtb-domain-edit',
    props: ['id'],
    data() {
        return {
            item: undefined,
            form: {
                domain: undefined,
                typeId: undefined,
            },
            dicts: {
                domainStatuses: []
            },
            errors: {
                name: ''
            }
        }
    },
    components: {
        'v-select': vSelect
    },
    methods: {
        loadDicts() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.$axios({
                url: 'domains/dicts',
                method: 'GET',
                success: (dicts) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.dicts.domainStatuses = dicts.domainStatuses;
                    this.dicts.domainTypes = dicts.domainTypes;
                },
                catch: (err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки справочников.',
                        color: 'danger'
                    });
                }
            });
        },
        loadData() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.axios.get('domains/' + this.id)
                .then((item) => {
                    this.item = item.data;
                    this.form.domain = item.data.domain;
                    this.form.statusId = item.data.statusId;
                    this.form.typeId = item.data.typeId;
                })
                .catch((err) => {
                    this.$vs.notify({
                        title: "Ошибка!",
                        text: "Ошибка загрузки домена.",
                        color: "danger",
                    });
                })
                .finally(() => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                });
        },
        save() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            const params = {
                id: this.id,
                domain: this.form.domain,
                statusId: this.form.statusId,
                typeId: this.form.typeId,
            };
            this.$axios({
                method: 'PUT',
                url: 'domains/' + this.id,
                params: params,
                errors: this.errors,
                success: (user) => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    this.$vs.notify({
                        title: "Успешно обновлено",
                        text: "Домен успешно обновлен",
                        color: "success",
                    });
                    this.$router.push('/rtb-domains');
                },
                catch: (err) => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    return this.$vs.notify({
                        title: "Внимание!",
                        text: "Ошибка при редактировании домена!",
                        color: "danger",
                    });
                }
            })
        },
        cancelEdit() {
            this.$router.push('/rtb-domains');
        }
    },
    mounted() {
        this.loadDicts();
        this.loadData();
    }
}
</script>

<style>
.select-error>div {
    border: 1px solid rgba(var(--vs-danger), 1) !important;
}
</style>